import gql from 'graphql-tag';

const CAMPAIGN_ORDER_TRANSACTION_CREATIVES_BY_DATES_PAGINATED = gql`
  query campaignOrderTransactionCreativesByDatesPaginated(
    $where: CampaignOrderTransactionCreativesByDateWhereInput!
    $first: Int
    $skip: Int
    $orderBy: CampaignOrderTransactionCreativesByDateOrderByInput
  ) {
    campaignOrderTransactionCreativesByDatesConnection(
      first: $first
      skip: $skip
      orderBy: $orderBy
      where: $where
    ) {
      pageInfo {
        hasNextPage
      }
      edges {
        cursor
        node {
          id
          date
          transactions
          impressions
          creative {
            media
            name
          }
        }
      }
      aggregate {
        count
      }
    }
    full: campaignOrderTransactionCreativesByDatesConnection(where: $where) {
      aggregate {
        count
      }
    }
  }
`;

export default CAMPAIGN_ORDER_TRANSACTION_CREATIVES_BY_DATES_PAGINATED;
